<template>
  <div>
    <Modal @closeDialog="visible = false" :visible="visible" :errorMessage="errorMessage"></Modal>
    <hot-table :data="hotdata" :settings="settings" :dataSchema="dataschema" ref="hot"></hot-table>

    <div class="console well" v-if="toggleEditHistory">
      <span v-for="(item) in editMessages">
        <span style="display: block; font-size: 12px" v-html="item"></span>
        <hr />
      </span>
    </div>

    <!-- This modal contains the second HOT instance for related tables -->
    <div v-show="openSecondHot" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <p class="text-center" style="font-size: 16px; color: red" v-if="secondHotError">{{ secondHotError }}</p>
            Select {{ allowMultipleValuesFromForeignTable ? "one or multiple" : "a" }} {{ relatedTable }}
            {{ allowMultipleValuesFromForeignTable ? "records" : "record" }}
          </div>
          <div class="modal-body">
            <slot name="body" class="text-center">
              <div v-if="loading" class="fa-3x text-center">
                <i class="fas fa-spinner fa-spin"></i>
              </div>

              <!-- Generate search inputs dynamically based on the columns from related table -->
              <div v-if = "shouldDisplaySecondSearch()">
               <span v-for="cols in secondHotColumns.slice(1)">
                    <input type="text" :placeholder="cols.title" :ref="cols.data" />
                 </span>
              <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="exactMatch" v-model="exactMatch" />
                  <label class="custom-control-label" for="exactMatch">Exact match</label>
              </div>
              <div class="text-center">
                <button class="btn btn-primary" style="margin-top: 10px; margin-bottom: 10px; margin-right: 10px; width: 125px" @click="secondHotOnSearch">Search</button>
                <a :href="`/add/${relatedTable}`" target="_blank"><button class="btn btn-success" style="margin-top: 10px; margin-bottom: 10px; margin-right: 10px; width: 125px" @click="secondHotOnSearch">Add Record</button></a>
              </div>
              </div>
              <div v-else>
                  <a :href="`/add/${relatedTable}`" target="_blank"><button class="btn btn-success" style="margin-top: 10px; margin-bottom: 10px; margin-right: 10px; width: 125px" @click="secondHotOnSearch">Add Record</button></a>
              </div>
              <!-- Second Hot Instance -->
              <hot-table :data="secondHotData" :settings="secondHotSettings" :columns="secondHotColumns" ref="secondHot"></hot-table>
            </slot>
          </div>
          <div>
            <slot name="footer">
              <div style="padding-bottom: 10px">
                <span v-if="allowMultipleValuesFromForeignTable" style="font-weight: bold">Selected Values: </span>
                <span v-for="(item, index) in idsAndNamesFromForeignTable">
                  <span><i v-on:click="removeItemInSecondHot(item.id)" class="fa fa-times fa-link"></i> {{ item.name }}</span
                  ><span v-if="index + 1 < idsAndNamesFromForeignTable.length">, </span>
                </span>
              </div>
             <button
                v-if="allowMultipleValuesFromForeignTable"
                style="margin-right: 20px"
                class="btn btn-large btn-primary text-center"
                v-on:click="submitSecondHot"
              >
                Submit
              </button>
              <button class="btn btn-large btn-default btn-danger text-center" v-on:click="closeSecondHot">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal -->
    <trumbowyg-editor :inputData.sync="editorData" :noHtml="wysiwygNoHtml" @update="editorData = $event;updateCellWithTrumbowygContents();" @close="editorData='';"></trumbowyg-editor>
    <file-editor
      :inputData.sync="editorData"
      @update="
        updateCellWithFileContents($event);
      "
      @clearPhoto="removePhoto();"
    ></file-editor>
  </div>
</template>

<script>
import { HotTable } from "@handsontable/vue";
import Handsontable from "handsontable";
import validator from "../../node_modules/@bp_api4/schema_validation/index.js";
import Modal from "./shared/Modal";
import TrumbowygContainer from "./shared/TrumbowygContainer";
import FileEditorContainer from "./shared/FileEditorContainer";
import { registerAllModules } from 'handsontable/registry';
import { deleteMixin, insertMixin, updateMixin } from "../mixins/crud.js";

registerAllModules();
export default {
  name: "HandsOnTable",
  components: {
    HotTable,
    Modal,
    "trumbowyg-editor": TrumbowygContainer,
    "file-editor": FileEditorContainer
  },
  mixins: [
    deleteMixin,
    insertMixin,
    updateMixin,
  ],
  props: ["hotdata", "table", "columns", "getFilteredData", "toggleEditHistory","maxRows","columnSorting","dataschema"],

  methods: {
    updateCellWithTrumbowygContents() {
      // After WYSIWYG editor is submitted, its content is synced up to this.editorData,
      // so we just have to take that data and send it into the previously-selected HoT cell
      this.$refs.hot.hotInstance.setDataAtCell(this.selectedCell.row, this.selectedCell.column, this.editorData);
    },
    closeSecondHot() {
      // This will close the HOT on 'cancel' button
      this.openSecondHot = false;
      this.secondHotError = null;
      // Reset search input values
      try{
        this.secondHotColumns.slice(1).forEach(col => {
          this.$refs[col.data][0].value = "";
        });
      }catch (e) {
        //empty
      }
    },
    submitSecondHot() {
      // This will close the HOT but also update necessary values on 'submit' button
      // Only used when able to select multiple values from related table
      
      let idField = this.$refs.hot.hotInstance.getCellMeta(this.cellRowClicked, this.cellColClicked).__proto__.data;
      //let colToRender = this.$refs.hot.hotInstance.getCellMeta(this.cellRowClicked, this.cellColClicked).__proto__.colToRender;
      if (this.idsAndNamesFromForeignTable.length == 0 && !(this.$refs.hot.hotInstance.getCellMeta(this.cellRowClicked, this.cellColClicked).__proto__.title).includes('**')){
        this.$refs.hot.hotInstance.setCellMeta(this.cellRowClicked, this.cellColClicked, 'valueToRender', ' '); 
        this.$refs.hot.hotInstance.setDataAtRowProp(this.cellRowClicked, idField, null);
      } else if (this.idsAndNamesFromForeignTable.length != 0 ) { 
      // Set the IDs to the ID column
      this.$refs.hot.hotInstance.setCellMeta(this.cellRowClicked, this.cellColClicked, 'valueToRender', this.idsAndNamesFromForeignTable.map(({ name }) => name).toString());
        
     this.$refs.hot.hotInstance.setDataAtRowProp(this.cellRowClicked, idField, this.idsAndNamesFromForeignTable.map(({ id }) => id).toString());
    }

      this.openSecondHot = false;
      // Reset search input values
      this.secondHotColumns.slice(1).forEach(col => {
        this.$refs[col.data][0].value = "";
      });
    },
    removeItemInSecondHot(id) {
      this.idsAndNamesFromForeignTable = this.idsAndNamesFromForeignTable.filter(obj => obj.id !== id);
    },
    updateCellWithFileContents(event) {
      // On the add, we must set the cell meta so we have access to the file ID as it relates to the file table to use it in the payload
      // As well as the photo name (example: person.jpg) so we can render it
      // event is coming from ImageProcessor -> FileEditorContainer -> here; it's an object with id and name
      if(this.$route.path.includes('add')) {
        this.$refs.hot.hotInstance.setCellMeta(this.cellRowClicked, this.cellColClicked, 'photoInfo', event);
        this.$refs.hot.hotInstance.setDataAtCell(this.cellRowClicked, this.cellColClicked, Number(event.file));
      } else if (this.table === 'tiktok_people_photos') {
        // fill in photo data in empty cells across the row
        const rowSourceData = this.$refs.hot.hotInstance.getSourceDataAtRow(this.cellRowClicked);
        const photoKeys = Object.keys(rowSourceData).filter(k => k.includes('photo_'));
        
        let cellData;
        for (const key of photoKeys) {
          cellData = rowSourceData[key];
          if (!cellData.name) {
            // update with the entire event object, so that we have the ID available for deletes
            this.$refs.hot.hotInstance.setDataAtRowProp(this.cellRowClicked, key + `.name`, event.name);
            this.$refs.hot.hotInstance.setDataAtRowProp(this.cellRowClicked, key + `.id`, event.id);
            return;
          }
        }
      } else {
        // In the edit, we don't need the extra meta, since the file is added to the people record after the photo is uploaded
        // After FileEditor is submitted, its content is synced up to this.editorData,
        // so we just have to take that data and send it into the previously-selected HoT cell
        this.updateWorkflowActionIds(this.cellRowClicked, this.cellColClicked, event.id);
        this.$refs.hot.hotInstance.setDataAtCell(this.cellRowClicked, this.cellColClicked, event.name);
      }

    },
    /**
     * After a cell's related record is replaced (e.g. a new file uploaded), points other columns' workflow_actions at the new record, so that edits to them (e.g. photo Source, Licensed) update the new record instead of the old one
     * @param {integer} row - HOT visual row index of the replaced cell
     * @param {integer} col - HOT visual column index of the replaced cell
     * @param {integer} newId - ID of the new record in the cell's related table
     */
    updateWorkflowActionIds(row, col, newId) {
      const hot = this.$refs.hot.hotInstance;
      const relatedTable = hot.getCellMeta(row, col).relatedTable;
      if (!relatedTable || !newId) {
        return;
      }

      const viewIdColumns = new Set();
      for (const { workflowActions } of this.columns) {
        if (workflowActions && workflowActions.tableName === relatedTable && workflowActions.viewIdColumn) {
          viewIdColumns.add(workflowActions.viewIdColumn);
        }
      }

      // use setSourceDataAtCell instead of setDataAtRowProp, because the ID column may not be visible
      const physicalRow = hot.toPhysicalRow(row);
      for (const viewIdColumn of viewIdColumns) {
        hot.setSourceDataAtCell(physicalRow, viewIdColumn, Number(newId));
      }
    },
    removePhoto() {
      console.log("REMOVE PHOTO CALLED");
      this.$refs.hot.hotInstance.setDataAtCell(this.cellRowClicked, this.cellColClicked, null);
    },
    secondHotSearch() {
      let query = {
        where: {
          logicalOperator: "all",
          children: []
        },
        table: this.relatedTable,
        limit: 50,
        offset: 1
      };
      let searchOperator = this.exactMatch === true ? 'equal' : 'contains';
      this.exactMatch = '';
      this.secondHotColumns.slice(1).forEach(col => {
        let columnToSearchOn;

        // If searching on JSON, convert column name path to nested json syntax
        if (col.data.includes(".")) {
          if (col.data.split(".").length >= 3) {
            columnToSearchOn = col.data.split(".").join("'->'") + "'";
            columnToSearchOn = columnToSearchOn.replace("'->", "->");
            columnToSearchOn = columnToSearchOn.replace(/->'([^->]*)$/, "->>'" + "$1");
          } else {
            columnToSearchOn = col.data.split(".").join("->'") + "'";
            columnToSearchOn = columnToSearchOn.replace(/->([^->]*)$/, "->>" + "$1");
          }
        } else {
          columnToSearchOn = col.data;
        }
        if (this.$refs[col.data][0].value.trim()) {
          // Trim whitespace from inputs.
          query.where.children.push(
            // Build the query like the queryBuilder does it to pass to backend.
            {
              type: "query-builder-rule",
              query: {
                rule: columnToSearchOn + "::text",
                selectedOperator: searchOperator,
                selectedOperand: col.data,
                value: this.$refs[col.data][0].value
              }
            }
          );
        }
      });
       if (this.relatedTable == 'committee_officeholders'){  // if related table is committee_officeholders we want to limit to people who could be members of the committee
            query.where.children.push(
              {
              type: "query-builder-rule",
              query: {
                rule: 'committee_id',
                selectedOperator: 'equal',
                selectedOperand: "committee_officeholders_view.committee_id",
                value: this.relatedCommittee
              }
            }
            )
          }
        //only return state legislation/bt50_staging categories that fall under the topic area of the bill 
        else if (this.relatedTable === 'state_legislation_categories' && (this.table === 'bt50_staging' || this.table === 'state_legislation')){
        let queryCol = "(state_legislation_categories_view.topic_area->>'id')::int"
        let this_topic_area = this.topic_area; 
        query.where.children.push({type:"query-builder-rule",
                          query:{rule:queryCol ,selectedOperator:"equal",value: this_topic_area.id}})
      } 
      this.secondHotQuery = query;

      console.log(JSON.stringify(this.secondHotQuery));
    },
    shouldDisplaySecondSearch(){
      if (this.relatedTable === 'stages' && this.table === 'candidate_stage_results'){  
        return false;
      }
      if (this.relatedTable === 'state_legislative_sessions' && this.table === 'bt50_staging'){
        return false;
      }
      return true;
    
    },
    async secondHotOnSearch() {
      this.secondHotSearch();
      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;

      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: "POST",
        headers: headers,
        credentials: 'include',
        body: JSON.stringify(this.secondHotQuery)
      });

      if ( response.status == 403 ) {
        response = await response.json();
        alert(response.message);
        window.location.href = '/login';
      } else {
        response = await response.json(); // Convert response to JSON

        if (response.success === true) {
           this.secondHotData.splice(0, this.secondHotData.length); // Clear the array
           response.data.forEach(item => {
            this.secondHotData.push(item);
          });
         } else {
          console.log("ERROR ON SECOND HOT SEARCH");
          this.secondHotError = 'Error searching on related table.';
        }
      }
    },
    parseFrontendError(validate) {
      let errorId = Number(Object.keys(validate.errors));
      let errCol = Object.keys(validate.errors[errorId]).toString();
      let errMsg = validate.errors[errorId][errCol].toString();
      return `Id: ${errorId} - ${errMsg}`;
    },
    getDataForRelatedTable: async (columnMetaData, whereClause = null) => {
     
      let query = {
        where: whereClause,
        table: columnMetaData.relatedTable,
        limit: 20,
        offset: 1
      };
      let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;

      let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
        method: "POST",
        headers: headers,
        credentials: 'include',
        body: JSON.stringify(query)

      });

      if ( response.status == 403 ) {
        response = await response.json();
        alert(response.message);
        window.location.href = '/login';
      } else {
        response = await response.json();
        return response;
      }
    },
    formatUpdatedValue(updatedValue, dataType) {
      try{
          if ( (dataType === 'integer' && updatedValue != null) || (dataType === 'numeric' && updatedValue != null) ) {
            updatedValue =  updatedValue.toString().replace(/,/g, '');
          }
          if (typeof updatedValue === "string") {
            updatedValue = updatedValue.trim(); // Value of cell after change
            updatedValue = updatedValue.length === 0 ? null : updatedValue;
          }

          if (dataType === "ARRAY" && updatedValue) {
            updatedValue = `{${updatedValue}}`;
          }

          if (updatedValue === "true" || updatedValue === "false" || (!isNaN(updatedValue) && updatedValue != null && updatedValue.length > 0 && dataType!=='character varying' && dataType!=='text')) {
            updatedValue = JSON.parse(updatedValue);
          }
          updatedValue = updatedValue == null ? null : updatedValue;
          return updatedValue;
      } catch (e) {
          return this.notValidTypeMessage;

      }
      
    }
   
  },

  data: function() {
    return {
      columnMoved: false,
      settings: {
        preventOverflow: "horizontal",
        filters: true,
        comments: true,
        licenseKey: "non-commercial-and-evaluation",
        manualRowMove: true,
        manualColumnMove: true,
        exportFile: true,
        manualRowResize: true,
        manualColumnResize: true,
        autoRowSize: false,
        manualColumnFreeze: true,
        contextMenu: ["freeze_column", "unfreeze_column"],
        height: 600,
        maxRows: this.maxRows,
        columns: this.columns,
        fixedColumnsLeft: 0,
        currentRowClassName: 'currentRow',
        currentColClassName: 'currentCol',
        columnSorting: this.columnSorting,
        fillHandle: {
             autoInsertRow: false,
             autoInsertColumn: false,
             direction: 'vertical'
        },
        
        //cells: function(row, col) {  // Example of using html rendering
        //   let cellMeta = {};
        //   if (col === 3) {
        //     cellMeta.renderer = 'safeHtmlRenderer'
        //   }
        //     return cellMeta;
        // },
        hiddenColumns: {
          columns: []
        },
        rowHeights: this.$route.path.includes('add') ? 25 : ['error_tracking','files', 'submitted_photos_staging', 'tiktok_people_photos','survey_staging', 'vote_in_person','vote_by_mail','ballot_measures'].includes(this.table) ? 120 : 70,
        contextMenu: {
          items: {
            Descriptions: {
              name: "Description",
              Description: function(key, selection, clickEvent) {},
              callback: (key, selection, clickEvent) => {
                let test = this.$refs.hot.hotInstance.getCellMeta(selection[0].start.row, selection[0].start.col);
                this.errorMessage = test.__proto__.description;
                if (!this.errorMessage) {
                  this.errorMessage = "No description available";
                }
                this.visible = true;
              }
            }
          }
        },
        afterColumnMove: () => {
          if(this.$route.path.includes('add')) {
            localStorage.setItem(`${this.table}-add`, JSON.stringify(this.$refs.hot.hotInstance.getColHeader()));
          } else {
            localStorage.setItem(`${this.table}`, JSON.stringify(this.$refs.hot.hotInstance.getColHeader()));
          }
          this.columnMoved = true;
          this.$emit('columns-moved', this.columnMoved) // we need to have this in edit and add  view so we can manually persist the column order change
                                            
        },
       
        afterOnCellMouseDown: async (e, coords, td) => {
          if (coords.row < 0){
            coords.row = 0;
          }
          let columnMetaData = this.$refs.hot.hotInstance.getCellMeta(coords.row, coords.col).__proto__;
          if (columnMetaData.renderer === 'downLoadButton'){
            this.downLoadDocument(e, coords, td);
            return;
          }
          let isReadOnly = this.$refs.hot.hotInstance.getCellMeta(coords.row, coords.col);
          if ( columnMetaData.editor === "wysiwyg" || columnMetaData.editor === "wysiwygNoHtml" || columnMetaData.editor === "file" ) {
            let cellData = this.$refs.hot.hotInstance.getDataAtCell(coords.row, coords.col);

            this.selectedCell.row = coords.row;
            this.selectedCell.column = coords.col;
            this.selectedCell.data = cellData;
            this.editorData = cellData;
            this.wysiwygNoHtml = columnMetaData.editor === "wysiwygNoHtml";

            // This is usually set in the showSecondHot() function below, but if the click is too slow, this is never set for the file upload
            // therefore we set it here as well, may be redundant from above but will set here to avoid regression
            this.colToUpdate = columnMetaData.colToUpdate;
            this.cellRowClicked = coords.row;
            this.cellColClicked = coords.col;
          } 
          // for certain workflows, the submit button should call the API4 workflow endpoint
          else if (columnMetaData.renderer === 'submitButton') {
            const rowSourceData = this.$refs.hot.hotInstance.getSourceDataAtRow(coords.row);
            const response = await this.submitCustomWorkflow(rowSourceData, this.table);

            // deselect cell, so that the success or error color for the row shows instead of the current row highlight
            this.selectedCell.row = null;
            this.selectedCell.column = null;
            this.selectedCell.data = null;
            this.$refs.hot.hotInstance.deselectCell();

            // error message popup and turn row red
            if ( response.status == 403 ) {
              let response = await response.json();
              alert(response.message);
              window.location.href = '/login';
            } else if (response.success === false) {
              for (let j =0; j<this.$refs.hot.hotInstance.countCols(); j++ ){
                this.$refs.hot.hotInstance.setCellMeta(coords.row, j, 'className', 'validation-error');
              }
              let message = JSON.parse(response.message);
              this.errorMessage = message.message;
              this.visible = true;
              this.$refs.hot.hotInstance.render();
              return;
            }

            // show notifications for each insert and update
            response.data.forEach(obj => {
              if (obj.action === 'INSERT') {
                this.showInsertNotification(obj.id, obj.table);
              } else if (obj.action === 'UPDATE') {
                // display which columns were changed, and the value they were changed to
                for (let col of obj.columns_changed) {
                 for (const [key, value] of Object.entries(col)) {
                    this.showChangeNotification(obj.id, key, undefined, value, obj.table);
                  }
                }
              }
            });

            // turn entire row green to indicate success
            for (let j =0; j<this.$refs.hot.hotInstance.countCols(); j++ ){
              this.$refs.hot.hotInstance.setCellMeta(coords.row, j, 'className', 'success');
            }
            this.$refs.hot.hotInstance.render();
            return;
          }

          // Check for double click.  But if related field is readonly just return
          if (isReadOnly.readOnly === true){
            return;
          }
          let now = new Date().getTime();
          if (!(td.lastClick && now - td.lastClick < 200)) {
            td.lastClick = now;
            return;
          }
          this.showSecondHot(e, coords, td);

        },
        beforeKeyDown: event => { // this disables straight data entry in related table fields.  They need to be selected, pasted, or dragged.
         
          this.doBeforeKeyDown(event);
        
          if (event.ctrlKey === true && event.key === 'm'){
            this.doAfterCtrlM(event)
          }
         
        },
        beforePaste: (data, coords) => {
          data.forEach((row, rowIndex) => {
            row.forEach((value, colIndex) => {
              const cellMeta = this.$refs.hot.hotInstance.getCellMeta(
                coords[0].startRow + rowIndex,
                coords[0].startCol + colIndex
              );

              if (cellMeta.renderer !== 'nullAwareCheckbox') {
                return;
              }

              if (value === 'TRUE') {
                row[colIndex] = true;
              } else if (value === 'FALSE') {
                row[colIndex] = false;
              }
            });
          });
      },
        afterPaste: async (data, coords) =>{
          await this.doAfterPaste(data,coords);
        },
        
       afterSelection: async (row, col, row2, col2) => {
        
        // if a table has hidden columns from a workflow you cannot select multiple columns for cut and paste or drag and drop
        // Get hidden columns
        let  hiddenColumns =  this.$refs.hot.hotInstance.getSettings().hiddenColumns
        if (!hiddenColumns || !hiddenColumns.columns){
          return;
        }
         
        let isAnyHiddenColumnInSelection = false;
        for (let i = col; i <= col2; i++) {
        if (hiddenColumns.columns.includes(i)) {
            isAnyHiddenColumnInSelection = true;
            break;
        }
        }    
        if (col2 && col2 != col && isAnyHiddenColumnInSelection){
          window.alert('Selection in workflow contains hidden columns.');
          this.$refs.hot.hotInstance.deselectCell();
        
        }
       }, 
          beforeAutofill:   (selectionData, sourceRange, targetRange, direction) => {
          let rowCounter = -1;
          //let colToRender;
          let colCounter = -1;
          let source_range_row = sourceRange.from.row -1;
        
      
          for  (let i = targetRange.from.row; i <= targetRange.to.row; i++) {
            source_range_row++;
            if (source_range_row > sourceRange.to.row){
              source_range_row = sourceRange.from.row

            }
            rowCounter++;
            rowCounter = rowCounter > selectionData.length -1 ? 0 : rowCounter;

            for (let j = targetRange.from.col; j <= targetRange.to.col; j++) {
              colCounter++;
              colCounter = colCounter > selectionData[0].length -1 ? 0 : colCounter;
              
              if (this.$refs.hot.hotInstance.getCellMeta(i, j).__proto__.relatedTable) {
                              
              let this_value = this.$refs.hot.hotInstance.getCell(source_range_row , j).innerHTML 
              if (this.$refs.hot.hotInstance.getCellMeta(i, j).__proto__.renderer === "relatedTableRenderer") {
                  this.$refs.hot.hotInstance.setCellMeta(i,j, 'valueToRender', this_value);
                 
                  this.$refs.hot.hotInstance.render();
              }
             }

            }

          }
    
               return selectionData ;
  
         },
            
        beforeChange: (changes, source) => {
         
          if (changes) {
              for (const change of changes) {
               
               if (this.setColToRenderProp === true || change[2] === change[3]) {
                   //console.log('returning here because setColToRenderProp is true or change[2] === change[3]');
                   return;
                }
                this.changedRow = change[0];
                this.changedColumn = change[1];
                //console.log("changedColumn", this.changedColumn);
                let renderer = this.$refs.hot.hotInstance.getCellMeta(change[0], this.$refs.hot.hotInstance.propToCol(change[1])).__proto__.renderer;
                let cellMeta = this.$refs.hot.hotInstance.getCellMetaAtRow(change[0]);
              
                let col = cellMeta.filter(obj => {
                  return obj.__proto__.colToUpdate === change[1].substring(0, change[1].length - 3);
                });
                
                if (col.length > 0) {
                  
                   this.setColToRenderProp = true;
                   
                }
                //console.log("renderer", renderer);
                if (renderer.length > 0 && renderer === "nullAwareCheckbox"){
                  
                  let default_value = this.$refs.hot.hotInstance.getCellMeta(0, this.$refs.hot.hotInstance.propToCol(change[1])).__proto__.default_value;
                  //console.log("default_value",default_value );
                  let newValue = change[3];
                 
                  if (newValue === "TRUE" || newValue === "true" || newValue === true){
                    newValue = true;
                    change[3] = newValue;
                  } else if (newValue === "FALSE" || newValue === "false" || newValue === false){
                    newValue = false;
                    change[3] = newValue;
                  } else if ((newValue === " " || newValue === "null" || newValue === "NULL" ) && default_value  && !change[2]){
                    newValue = default_value;
                    change[3] = newValue;
                  } else if (newValue === null && !default_value ){  
                    newValue = null;
                    change[3] = newValue;
                  } else {
                   change[3] = change[2]; // if not true, false, or null, then revert to old value
                  }
                  let oldValue = change[2];
                  if (newValue !== true && newValue !== false && newValue !== null) {
                      change[3] = oldValue; 
                } 
              
              }

              }
            }

        },
        afterChange: changes => {
          if (this.setColToRenderProp === true) {
            this.setColToRenderProp = false;
          }
          this.doChanges(changes);
          this.$refs.hot.hotInstance.render();
         },
        beforeUndo: async action => {
          let changes = action.changes
          for await (const change of changes){
                let cellMeta = this.$refs.hot.hotInstance.getCellMetaAtRow(change[0]);
                let colToChange = this.$refs.hot.hotInstance.colToProp(change[1]);
                let col = cellMeta.filter(obj => {
                if (obj.__proto__.readOnly === false && obj.__proto__.data === colToChange){
                     return obj
                   }
                });
                if (col.length > 0 && change[2] != "" && change[2] != null){ // related table need to lookup value
               
                  if (this.$refs.hot.hotInstance.getCellMeta(change[0], col[0].visualCol).__proto__.relatedTable) {
                    let relatedTable = this.$refs.hot.hotInstance.getCellMeta(change[0], col[0].visualCol).__proto__.relatedTable;
                    let colToUpdate = this.$refs.hot.hotInstance.getCellMeta(change[0], col[0].visualCol).__proto__.colToUpdate;
                    let colToRender = this.$refs.hot.hotInstance.getCellMeta(change[0], col[0].visualCol).__proto__.colToRender;
                    let alias = this.$refs.hot.hotInstance.getCellMeta(change[0], col[0].visualCol).__proto__.colRenderAlias;
                    let response = await this.getRelatedData(relatedTable,change[2]);

                 let responseField = alias ? alias.replace(`${colToUpdate}.`,'') : colToRender.replace(`${colToUpdate}.`,'');
                 let stringToRender = this.buildStringToRender(response, responseField)
                 this.$refs.hot.hotInstance.setCellMeta(change[0],col[0].visualCol, 'valueToRender', stringToRender.slice(0,-1));
                 this.$refs.hot.hotInstance.render();
                }
              }
              if (col.length > 0 && (change[2] === "" || change[2] == null)){
                  this.$refs.hot.hotInstance.setCellMeta(change[0],col[0].visualCol,'valueToRender',' ');
                  this.$refs.hot.hotInstance.render();

               }
            }
           },
        },
      async doAfterPaste(data, coords) {
        // if this related table field we need to get the related display information from the database
        let rowCounter = coords[0].startRow - 1;
        let dataRowCounter = -1;
        let dataColCounter = -1;
        //let colToRender;
        for (let i = coords[0].startRow; i <= coords[0].endRow; i++) {
          rowCounter++;
          dataColCounter = -1;
          dataRowCounter++;
          for (let j = coords[0].startCol; j <= coords[0].endCol; j++) {
              dataColCounter++;
              if (this.$refs.hot.hotInstance.getCellMeta(i, j).__proto__.relatedTable) {
              let relatedTable = this.$refs.hot.hotInstance.getCellMeta(i, j).__proto__.relatedTable;
              let colToUpdate = this.$refs.hot.hotInstance.getCellMeta(i, j).__proto__.colToUpdate;
              let colToRender = this.$refs.hot.hotInstance.getCellMeta(i, j).__proto__.colToRender;
              let alias = this.$refs.hot.hotInstance.getCellMeta(i, j).__proto__.colRenderAlias;
             
              let response = await this.getRelatedData(relatedTable,this.$refs.hot.hotInstance.getDataAtCell(i, j));
              let responseField = alias ? alias.replace(`${colToUpdate}.`,'') : colToRender.replace(`${colToUpdate}.`,'');
              let stringToRender = this.buildStringToRender(response, responseField)
              if (this.$refs.hot.hotInstance.getCellMeta(i, j).__proto__.renderer === "relatedTableRenderer") {
                   this.$refs.hot.hotInstance.setCellMeta(i,j, 'valueToRender', stringToRender.slice(0,-1));
                   this.$refs.hot.hotInstance.render();
              }
             }
            }
        }
      },
      async doAfterCtrlM(event){
         let selected = this.$refs.hot.hotInstance.getSelected();

             let coords = {
                row: selected[0][0],
                col: selected[0][1],
                last_row: selected[0][2],
                last_column: selected[0][3]
              };
          
             if (coords.col != coords.last_column){
                window.alert("Ctrl m can copy only one column");
             }else  
               if (this.$refs.hot.hotInstance.colToProp(coords.col).slice(-3) != '.id'){
               window.alert("Ctrl m can only be used on foreign key fields");
             }else{
          //  add check that it is a foreign key field.
            // starting in version 8 if the column is selected the header is returned as a negative row. We don't want that                               
             let csv_list= '';
             for (let i =  coords.row; i <= coords.last_row; i++){
              if (i >= 0 ){
                  csv_list = csv_list + this.$refs.hot.hotInstance.getDataAtCell(i,coords.col) ;
                  csv_list = csv_list + ', ';
                }
              }
              let textArea = document.createElement("textarea");
              textArea.value = csv_list.slice(0,-2);
              document.body.appendChild(textArea);
              textArea.select();
              
             try {
                document.execCommand("copy");
                
              } catch (err) {
                 //empty
              }
              document.body.removeChild(textArea);
            }

      },
      async doBeforeKeyDown(event){
          let selected = this.$refs.hot.hotInstance.getSelected();
          let coords = {
            row: selected[0][0],
            col: selected[0][1]
          };
          let cellMeta = this.$refs.hot.hotInstance.getCellMeta(selected[0][0], selected[0][1]);
          if (!event.ctrlKey && !event.Meta && !event.metakey && event.key !== "Delete" && event.key !== "Tab" && event.key !=='Backspace' && !event.key.includes('Shift') && !event.key.includes('Arrow') &&!event.key.includes('F') && event.code !== 'MetaLeft' && event.code !== 'MetaRight' && event.code !== 'KeyV'){
            //let cellMeta = this.$refs.hot.hotInstance.getCellMeta(selected[0][0], selected[0][1]);
            if (cellMeta.__proto__.renderer === "relatedTableRenderer") {
              event.stopImmediatePropagation();
              if (!this.gettingSecondHotData){// if multiple keys are hit we were getting multiple lookups - so this keeps it to just one.
                 this.gettingSecondHotData = true;
                 await this.showSecondHot(null, coords, null);
                 this.gettingSecondHotData = false;
              }
            }
          }
          if ( (event.key === "Delete" || event.key ==='Backspace')){ // if delete or backspace for a related table we want to loop trough all of them and delete the valueToRender
             for (let i = selected[0][0]; i <= selected[0][2]; i++){
               for (let j= selected[0][1]; j <= selected[0][3]; j++ ){
                   let is_related_field = this.$refs.hot.hotInstance.getCellMeta(i,j).__proto__.renderer
                   if (is_related_field){
                    this.$refs.hot.hotInstance.setCellMeta(i, j,'valueToRender',' ');
                   } 
               }
              }
             this.$refs.hot.hotInstance.render();
            }
    },
    async doChanges(changes) {

        // This function is called whenever a cell is touched and then navigated away from.
        if (changes) {
          for await (const change of changes) {
            let [rowIdx, columnName, currentValue, updatedValue] = change;
            if (change == null || ['promoteselected', 'columnselected', 'id', 'page_results', 'page_templates', 'promotetogold'].includes(columnName)) {
              // The function also fires when the table first loads and returns null, check null and kill function.
              continue;
            }

            const colIdx = this.getColumnNumber(columnName);
            const columnMetaData = this.$refs.hot.hotInstance.getCellMeta(rowIdx, colIdx).__proto__;
            const dataType = columnMetaData.dataType;
            updatedValue = this.formatUpdatedValue(updatedValue, dataType);
            if (updatedValue === this.notValidTypeMessage){
                this.updateErrorValue(this.$refs.hot.hotInstance.toVisualRow(rowIdx), colIdx, updatedValue)
                continue;
            }

            if (currentValue === change[3] || currentValue === updatedValue) {
              // no change so no need for a database call (compare to both formatted and original values)
              continue;
            }
            
            // at this point, we're going to try updating the table (or performing a workflow action)
            const rowData = this.$refs.hot.hotInstance.getSourceDataAtRow(rowIdx);
            const id = Number(rowData.id); // Get row ID and convert to number

            if (columnName.includes(".id") && !columnName.includes("photo_")) {
              columnName = columnName.substring(0, columnName.length - 3); // this means we are dealing with a related table.  We just want the related table name without the id
            }

            this.clearErrorValue(this.$refs.hot.hotInstance.toVisualRow(rowIdx), colIdx);
            if (
              isNaN(Number(this.$refs.hot.hotInstance.getSourceDataAtRow(rowIdx).id)) ||
              !this.$refs.hot.hotInstance.getSourceDataAtRow(rowIdx).id
            ) { // adds leave here.
              if (this.table === "people") {
                // Logic for automatically appending Name and URL after first and last name are added in ADD page only.
                let first_name = this.$refs.hot.hotInstance.getDataAtRowProp(rowIdx, "first_name");
                let last_name = this.$refs.hot.hotInstance.getDataAtRowProp(rowIdx, "last_name");
                let url = this.$refs.hot.hotInstance.getDataAtRowProp(rowIdx, "url");
                let name = this.$refs.hot.hotInstance.getDataAtRowProp(rowIdx, "name");

                if (first_name && last_name && !name) {
                  this.$refs.hot.hotInstance.setDataAtRowProp(rowIdx, "name", `${first_name} ${last_name}`);
                }

                if (name && !url) {
                  this.$refs.hot.hotInstance.setDataAtRowProp(rowIdx, "url", `https://ballotpedia.org/${name.replace(/ /g, "_")}`);
                }
              }
              continue;
            }

            // similar logic as in people table add for filling out full person name and Metabase URL automatically
            if (this.table === "school_board_research_worksheet") {
              let first_name = this.$refs.hot.hotInstance.getDataAtRowProp(rowIdx, "new_oh_first_name");
              let last_name = this.$refs.hot.hotInstance.getDataAtRowProp(rowIdx, "new_oh_last_name");
              let name = this.$refs.hot.hotInstance.getDataAtRowProp(rowIdx, "new_oh_name");
              let state = this.$refs.hot.hotInstance.getDataAtRowProp(rowIdx, "state");
              let metabase_url = this.$refs.hot.hotInstance.getDataAtRowProp(rowIdx, "metabase_url");

              if (first_name && last_name && !name) {
                this.$refs.hot.hotInstance.setDataAtRowProp(rowIdx, "new_oh_name", `${first_name} ${last_name}`);
              }

              if (first_name && last_name && state && !metabase_url) {
                const url = `https://metabase.ballotpedia.org/question/2475-people-disambig-for-school-board-research-worksheet?first_name=${first_name}&last_name=${last_name}&state=${state}`;
                this.$refs.hot.hotInstance.setDataAtRowProp(rowIdx, "metabase_url", url);
              }
            }

            // custom workflow 2.0: insert/update/delete in another table
            if (columnMetaData.workflowActions) {
              const { tableName, viewIdColumn, insertValues, updateColumn, canDelete } = columnMetaData.workflowActions;
              let otherTableId = null;
              if (viewIdColumn) {
                // get the ID--works with normal column or JSON column in view (e.g. personId or person.id)
                otherTableId = Number(viewIdColumn.split('.').reduce((obj, key) => {
                  if (key in obj) {
                    return obj[key];
                  }
                }, rowData));
              }
              const visualRowIdx = this.$refs.hot.hotInstance.toVisualRow(rowIdx);

              if (!tableName || (!insertValues && !updateColumn && !canDelete)) {
                this.updateErrorValue(visualRowIdx, colIdx, 'Invalid column_descriptions.workflow_actions');
                continue;
              }
              
              if (insertValues && !otherTableId && updatedValue !== null) {
                await this.insertDifferentTable(tableName, viewIdColumn, insertValues, rowData, rowIdx, colIdx);
              } else if (canDelete && otherTableId && updatedValue === null) {
                await this.deleteDifferentTable(tableName, otherTableId, viewIdColumn, rowIdx, colIdx);
              } else if (updateColumn && otherTableId) {
                await this.updateColumnInTable(tableName, otherTableId, updateColumn, currentValue, updatedValue, rowIdx, colIdx);
              } else {
                this.updateErrorValue(visualRowIdx, colIdx, 'Invalid action');
                continue;
              }
            }

            // custom workflow --> check if we need to update another table
            else if (columnMetaData.workflowUpdates && columnMetaData.workflowUpdates.length > 0) {
              for (let updateInfo of columnMetaData.workflowUpdates) {
                // if ID is null, it's an insert, not an update
                if (rowData[updateInfo.id]) {
                  await this.updateColumnInTable(updateInfo.table, rowData[updateInfo.id], updateInfo.column, currentValue, updatedValue, rowIdx, colIdx);
                }
              }
            }

            // normal table
            else {
              await this.updateColumnInTable(this.$props.table, id, columnName, currentValue, updatedValue, rowIdx, colIdx);
            }
          }
        }
      },
      async getRelatedData(table, ids ) {
        let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
         // this is a view to limit officeholders to those who could be in a certain committee.  for getting related data we want to use the officeholder view directly
        if (table === 'committee_officeholders') { 
          table = 'officeholders' 
        }
        
        headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud?table=${table}&ids=${ids}`;

        let response = await fetch(
          `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
          {
            method: "GET",
            headers: headers,
            credentials: 'include'
          }
        );

      if ( response.status == 403 ) {
        response = await response.json();
        alert(response.message);
        window.location.href = '/login';
        }
      else {
          response = await response.json();
          return response;
      }
      },
      buildStringToRender(response,responseField){
         responseField = responseField.split('.') ;
         let buildStringToRender="";
         let stringToRender="";

         for (let i = 0; i< response.data.length; i++){
              buildStringToRender = response.data[i];
               for (let i = 0; i< responseField.length; i++){
                      buildStringToRender = (buildStringToRender[responseField[i]])
                }
                stringToRender += `${buildStringToRender},`;

              }
          return stringToRender;
      },
      async showSecondHot(e, coords, td) {
        this.relatedCommittee = null;  // this is for querying committee members who can belong to a certain committee.  
        this.cellRowClicked = coords.row;
        this.cellColClicked = coords.col;
        let whereClause = null;
        /*
              When a cell is clicked we are checking its meta data to see if its from a related table
              If so, we pull up a second instance of hot to search and update the field.
          */

        this.idsAndNamesFromForeignTable = [];
        this.colToUpdate = null; // This is for updating a cell from a related table. For example clicking on a person's name from the view should update the 'person' ID column in the non-view version of that table.
        this.cellRowClicked = coords.row;
        this.cellColClicked = coords.col;
        const columnMetaData = this.$refs.hot.hotInstance.getCellMeta(coords.row, coords.col).__proto__;

        this.colToUpdate = columnMetaData.colToUpdate; // this is needed for uploading files

        // disable the 2nd HOT popup for this table on add pages only (it's confusing for volunteer researchers)
        if (this.table === 'candidate_endorsements_staging' && this.$route.path.includes('/add/')) {
          return;
        }
        if (!columnMetaData.relatedTable || columnMetaData.relatedTable === "files") {
          this.allowMultipleValuesFromForeignTable = false;
          return; // If no related table, kill function.
        }
        if (columnMetaData.relatedTable === 'stages' && this.table === 'candidate_stage_results'){ // only return stages related to the candidate's race
            let queryCol = "stages_view.race ->>'id'"
            let candidateId = this.$refs.hot.hotInstance.getDataAtCell(coords.row, this.$refs.hot.hotInstance.propToCol('candidate.id'));

            if (candidateId == null){
               this.updateErrorValue(coords.row,1,"A candidate must be chosen before selecting a stage");
              return;
            }
            let raceId = await this.getRelatedData('candidates',candidateId);
            raceId = raceId.data[0]['race']['id']
            raceId = raceId.toString();
            whereClause = {logicalOperator:"all",children:[{type:"query-builder-rule",
                           query:{rule:queryCol ,selectedOperator:"equal",value:raceId}}]}
        }
        else if (columnMetaData.relatedTable === 'public.candidates' && this.table === 'candidate_poll_results'){
            // only allow candidate selection if candidate_poll is chosen first
            let candidatePollId = this.$refs.hot.hotInstance.getDataAtCell(coords.row, this.$refs.hot.hotInstance.propToCol('candidate_poll.id'));

            if (candidatePollId == null){
               this.updateErrorValue(coords.row, 1, "A candidate poll must be chosen before selecting a candidate");
              return;
            }
            
            // Get stage from the poll, then get race from stage to filter candidates
            let pollData = await this.getRelatedData('candidate_polls', candidatePollId);
            let stageId = pollData.data[0]['stage']['id'];
            
            // Now get the race from the stage
            let stageData = await this.getRelatedData('stages', stageId);
            let raceId = stageData.data[0]['race']['id'].toString();
            
            // Filter candidates by this race
            let queryCol = "candidates_view.race ->>'id'";
            whereClause = {
                logicalOperator:"all",
                children:[{
                    type:"query-builder-rule",
                    query:{rule:queryCol, selectedOperator:"equal", value:raceId}
                }]
            };
        }
        // only show bt50 staging state when looking at legislative sessions
        else if (columnMetaData.relatedTable === 'state_legislative_sessions' && this.table === 'bt50_staging'){
          let queryCol = 'state_legislative_sessions_view.state'
          let this_state = this.$refs.hot.hotInstance.getDataAtRowProp(coords.row,'state')
          whereClause = {logicalOperator:"all",children:[{type:"query-builder-rule",
                           query:{rule:queryCol ,selectedOperator:"equal",value: this_state}}]}
        
        }
        //only show state legislation/bt50_staging categories that fall under the topic area of the bill 
        else if (columnMetaData.relatedTable === 'state_legislation_categories' && (this.table === 'bt50_staging' || this.table === 'state_legislation')){
          let queryCol = "(state_legislation_categories_view.topic_area->>'id')::int"
          let this_topic_area = this.$refs.hot.hotInstance.getDataAtRowProp(coords.row, 'topic_area')
          this.topic_area = this_topic_area;
          whereClause = {logicalOperator:"all",children:[{type:"query-builder-rule",
                           query:{rule:queryCol ,selectedOperator:"equal",value: this_topic_area.id}}]}
        } 
        else if (columnMetaData.relatedTable === 'committee_officeholders') {
        
          let queryCol = "committee_officeholders_view.committee_id"
          this.relatedCommittee = this.$refs.hot.hotInstance.getDataAtRowProp(coords.row, 'committee.id')
          whereClause = {logicalOperator:"all",children:[{type:"query-builder-rule",
                           query:{rule:queryCol ,selectedOperator:"equal",value: this.relatedCommittee}}]}
        }
        this.secondHotColumns = [
          {
            title: "Select",
            description: "Click to select record",
            type: "text",
            colWidths: 100,
            readOnly: true
          }
        ];

        columnMetaData.relatedTableColsToShow.forEach(col => {
          this.secondHotColumns.push(col);
        });

        this.colToUpdate = columnMetaData.colToUpdate;
        this.relatedTable = columnMetaData.relatedTable;
        this.openSecondHot = true;
        this.loading = true;
        //this.secondHotData = []; // Clear current table data.
        this.secondHotData.splice(0, this.secondHotData.length); // Clear the array

        this.allowMultipleValuesFromForeignTable = columnMetaData.allow_multiple_values;
        if (this.allowMultipleValuesFromForeignTable && this.$refs.hot.hotInstance.getDataAtCell(coords.row, coords.col) != null && this.$refs.hot.hotInstance.getDataAtCell(coords.row, coords.col).length >  0 ){
          let answer = await this.getRelatedData(columnMetaData.relatedTable,this.$refs.hot.hotInstance.getDataAtCell(coords.row, coords.col))
          let id;
          let name; 
          for ( let i=0;i<answer['data'].length;i++){
            id = answer['data'][i].id
            name = answer['data'][i].name
            this.idsAndNamesFromForeignTable.push({id, name })
          }
                   
        }
        let response = await this.getDataForRelatedTable(columnMetaData,whereClause);
        this.secondHotData.splice(0, this.secondHotData.length);
        //this.secondHotData = [];
       
        if (response.success === true) {
            response.data.forEach(item => {
            this.secondHotData.push(item);
           
          });
        } else {
          console.log("ERROR IN FILTERED DATA RESPONSE");
          this.secondHotError = 'Error getting data from related table.';
        }

        this.loading = false;
      },
      setUndo:(value) => {
       this.$refs.hot.hotInstance.updateSettings ({
              undo: value
        })

      },
      updateErrorValue: (row, column, message) => {
        const commentsPlugin = this.$refs.hot.hotInstance.getPlugin("comments");
        commentsPlugin.setCommentAtCell(row, column, message);
        this.$refs.hot.hotInstance.setCellMeta(row, column, "valid", false);
        this.$refs.hot.hotInstance.render();
      },
      getColumnNumber: (colIn) => {
        let changeFieldColumn;
        if (colIn.includes(".id") && !colIn.includes("photo_")) {
          //indicates that we are working with a related table field - so we need to find the field we are renedering
          const rowMeta = this.$refs.hot.hotInstance.getCellMetaAtRow(0);
          changeFieldColumn = rowMeta.filter(obj => {
            return obj.__proto__.colToUpdate === colIn.substring(0, colIn.length - 3);
          });
          changeFieldColumn = changeFieldColumn[0].visualCol;
        } else {
          changeFieldColumn = this.$refs.hot.hotInstance.propToCol(colIn);
        }
        return changeFieldColumn;
      },
      clearErrorValue: (row, column) => {
        const commentsPlugin = this.$refs.hot.hotInstance.getPlugin("comments");
        let comment = commentsPlugin.getCommentAtCell(row, column);
        if (comment) {
          commentsPlugin.removeCommentAtCell(row, column);
          this.$refs.hot.hotInstance.setCellMeta(row, column, "valid", true);
          this.$refs.hot.hotInstance.render();
        }
      },
      async downLoadDocument(e, coords, td) {
      
      let file_to_download = this.$refs.hot.hotInstance.getDataAtCell(coords.row,coords.col)  
      file_to_download = file_to_download.replace('https://','')
      file_to_download  = file_to_download.replace('.s3.amazonaws.com','')

      let f_array = file_to_download.split('/')
      
      let bucket_name = f_array[0]
      f_array.shift()
      let key = f_array.join('/')
           
      let mime_type = key.slice(-3)
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/files/get_presigned_url_get`;

      let response1 = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify({
            filename: key,
            mimetype: mime_type,
            bucket_name: bucket_name,
          }),
        }
      );
       response1 = await response1.json();
       let tempLink = document.createElement('a');
       tempLink.setAttribute('target', '_blank');
       tempLink.href = response1.data.url ;
       tempLink.click();
      },
     
      showChangeNotification(id, column, currentValue, updatedValue, table) {
        const advancedValues = ['Advanced - General', 'Advanced - Primary Runoff', 'Advanced - General Runoff'];
        let sentence;

        if (advancedValues.includes(updatedValue)) {
          sentence = `<b>${id}:</b> <i>${column}</i> changed from ${currentValue} to ${updatedValue} <br> A candidate stage result record was created for the ${updatedValue.split(' - ')[1]} stage.`;
        } else if (table) {
          sentence = `<b>${id} ${table}:</b> <i>${column}</i> changed`
          if (currentValue !== undefined) {
            sentence += ` from ${currentValue}`
          }
          if (updatedValue !== undefined) {
            sentence += ` to ${updatedValue}`;
          }
        } else {
          sentence = `<b>${id}:</b> <i>${column}</i> changed from ${currentValue} to ${updatedValue}`
        }

         // For Growl Notifications, but only show if edit history box is hidden.
        if(!this.toggleEditHistory) {
          this.$toastr.s(sentence)
        }
        // For log history box
        this.editMessages.unshift(sentence);
      },
      showInsertNotification(id, table) {
        if (id && table) {
          let sentence = `<b>${id} ${table}: row added`;
          if(!this.toggleEditHistory) { 
            this.$toastr.s(sentence);
          }
          this.editMessages.unshift(sentence);
        }
      },
      showDeleteNotification(id, table) {
        if (id && table) {
          let sentence = `<b>${id} ${table}: row deleted`;
          if(!this.toggleEditHistory) { 
            this.$toastr.s(sentence);
          }
          this.editMessages.unshift(sentence);
        }
      },
      async submitCustomWorkflow(dataObject, tableName) {
        if (Object.keys(dataObject).length > 0) {
          let payload = {
            data: [dataObject],
            table: tableName
          };

          let headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
          headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/custom_workflow`;

          let response = await fetch(`${process.env.VUE_APP_API4_DOMAIN}/users/authorize`, {
              method: "POST",
              headers: headers,
              credentials: 'include',
              body: JSON.stringify(payload)
            });
          response = await response.json();
          return response;
        }
      },
      /**
       * Validates and attempts to insert a row into a table using information from `column_descriptions.workflow_actions`
       * @param {string} tableName - `tableName` from `column_descriptions.workflow_actions, where row will be inserted`
       * @param {integer} viewIdColumn - `viewIdColumn` from `column_descriptions.workflow_actions`
       * @param {object} insertInfo - `insertValues` from `column_descriptions.workflow_actions`
       * @param {object} rowData - HOT source data at row
       * @param {integer} rowIdx - HOT physical row index
       * @param {integer} colIdx - HOT physical column index
       */
      async insertDifferentTable(tableName, viewIdColumn, insertInfo, rowData, rowIdx, colIdx) {
        const payload = {
          data: [{}],
          table: tableName
        };

        // for the insert, get values either directly from column_descriptions or from the view data
        for (const row of insertInfo) {
          if (row.valueSource === 'literal') {
            payload.data[0][row.targetColumn] = row.value;
          } else if (row.valueSource === 'view') {
            const insertColIdx = this.$refs.hot.hotInstance.propToCol(row.value);
            const insertColDataType = this.$refs.hot.hotInstance.getCellMeta(rowIdx, insertColIdx).__proto__.dataType;
            payload.data[0][row.targetColumn] = this.formatInsertPayloadItem(rowData[row.value], insertColDataType);
          } else {
            throw new Error('invalid valueSource in column_descriptions.workflow_actions.insertValues');
          }
        }

        let validate;
        try {
          validate = await this.validateInsert(payload, rowIdx);
        } catch (e) {
          console.log(e);
          return;
        }

        // Parse error, show warning modal
        if (validate.errors && Object.entries(validate.errors).length !== 0) {
          // TODO: ID = 0 if incorrect enum value for contact_type
          const message = this.parseFrontendError(validate);
          this.updateErrorValue(this.$refs.hot.hotInstance.toVisualRow(rowIdx), colIdx, message);
          return;
        }

        let insertResponse;
        try {
          insertResponse = await this.insertRecord(payload);
        } catch (e) {
          console.log(e);
          return;
        }

        if (insertResponse.success === false) {
          const errorMessage = JSON.parse(insertResponse.message).message;
          this.updateErrorValue(this.$refs.hot.hotInstance.toVisualRow(rowIdx), colIdx, errorMessage);
          return;
        }

        const newId = Number(insertResponse.data.id);
        
        // set the column value corresponding to the newly created record so that we can update/delete it later
        // have to use this function instead of setDataAtRowProp, because the cell isn't visible
        // this may be null if only allowing inserts (no updates or deletes)
        if (viewIdColumn) {
          this.$refs.hot.hotInstance.setSourceDataAtCell(rowIdx, viewIdColumn, newId);
        }
        this.showInsertNotification(newId, tableName);
        return;
      },

      /**
       * Attempts to delete a row from a table using information from `column_descriptions.workflow_actions`
       * @param {string} tableName - `tableName` from `column_descriptions.workflow_actions, where row will be deleted`
       * @param {integer} idToDelete - ID of row in other table to delete
       * @param {integer} viewIdColIdx - column index where ID of the row to delete is stored
       * @param {integer} rowIdx - HOT physical row index
       * @param {integer} colIdx - HOT physical column index
       */
      async deleteDifferentTable(tableName, idToDelete, viewIdColIdx, rowIdx, colIdx) {
        let deleteResponse;
        try {
          deleteResponse = await this.deleteRecords(tableName, [idToDelete]);
        } catch(e) {
          console.log(e);
          return;
        }

        deleteResponse = await deleteResponse.json();
        if (deleteResponse.success === false) {
          const errorMessage = JSON.parse(deleteResponse.message).message;
          this.updateErrorValue(this.$refs.hot.hotInstance.toVisualRow(rowIdx), colIdx, errorMessage);
          return;
        }

        // set the ID for what we just deleted to null, so that any new data will be inserted (if allowed)
        this.$refs.hot.hotInstance.setSourceDataAtCell(rowIdx, viewIdColIdx, null);
        this.showDeleteNotification(idToDelete, tableName);
      },

      /**
       * Validates and attempts to update a row in a table using information from `column_descriptions.workflow_actions`
       * @param {string} tableName - `tableName` from `column_descriptions.workflow_actions, where row will be updated`
       * @param {integer} idToUpdate - ID of row in other table to update
       * @param {string} columnToUpdate - name of column in other table that will be updated
       * @param {any} currentValue - current value of the updated column
       * @param {any} updatedValue - new value of the updated column
       * @param {integer} rowIdx - HOT physical row index
       * @param {integer} colIdx - HOT physical column index
       */
      async updateColumnInTable(tableName, idToUpdate, columnToUpdate, currentValue, updatedValue, rowIdx, colIdx) {
        const payload = this.formatUpdatePayload(tableName, idToUpdate, columnToUpdate, updatedValue);
        let validate;
        try {
          validate = await this.validateUpdate(payload, rowIdx);
        } catch (e) {
          console.log(e);
          return;
        }

        // Parse error, show warning modal
        if (validate && validate.errors && Object.entries(validate.errors).length !== 0) {
          let message = this.parseFrontendError(validate);
          this.updateErrorValue(this.$refs.hot.hotInstance.toVisualRow(rowIdx), colIdx, message);
          return;
        }

        let updateResponse;
        try {
          updateResponse = await this.updateRecord(payload);
        } catch (e) {
          console.log(e);
          return;
        }

        if (updateResponse.success === false) {
          const errorMessage = JSON.parse(updateResponse.message).message;
          this.updateErrorValue(this.$refs.hot.hotInstance.toVisualRow(rowIdx), colIdx, errorMessage);
        } else if (updateResponse.status == 403) {
          alert(updateResponse.message);
          window.location.href = '/login';
        } else {
          // TODO: normal table is slightly different (doesn't include tableName)
          this.showChangeNotification(idToUpdate, columnToUpdate, currentValue, updatedValue, tableName);
        }
      },

      editorData: "",
      wysiwygNoHtml: false,
      exactMatch: "",
      selectedCell: {
        row: null,
        column: null,
        data: null
      },
      colDescription: null,
      relatedCommittee: null,
      showDescriptions: false,
      visible: false,
      errorMessage: "Error",
      notValidTypeMessage: "Invalid value for column" ,
      changedRow: null,
      changedColumn: null,
      cellRowClicked: null,
      cellColClicked: null,
      setColToRenderProp: false,
      cellsAreAutoFill: false,
      loading: false,
      colToUpdate: null,
      gettingSecondHotData: false,
      openSecondHot: false,
      secondHotData: [],
      secondHotColumns: [],
      secondHotQuery: null,
      relatedTable: null,
      allowMultipleValuesFromForeignTable: false,
      idsAndNamesFromForeignTable: [],
      editMessages: [],
      secondHotError: null,
      secondHotSettings: {
        // Second HOT Instance Settings
        preventOverflow: "horizontal",
        filters: true,
        dropdownMenu: true,
        licenseKey: "non-commercial-and-evaluation",
        manualRowMove: true,
        manualColumnMove: true,
        dropdownMenu: true,
        exportFile: true,
        manualRowResize: true,
        manualColumnResize: true,
        autoRowSize: true,
        renderAllColumns: true,
        manualColumnFreeze: true,
        fillHandle: {
             autoInsertRow: false,
             autoInsertColumn: false,
             direction: 'vertical'
        },
        
        contextMenu: ["freeze_column", "unfreeze_column"],
        dropdownMenu: ["col_left", "col_right", "---------", "filter_by_condition", "filter_by_value", "filter_action_bar"],
        manualColumnFreeze: true,
        height: 300,
        readOnly: true,
        modifyColWidth: function(width, col) {
          if (width > 300) {
            return 300;
          }
        },
        cells: (row, col) => {
          const cellPrp = {};
          if (col === 0) {
            cellPrp.renderer = function(instance, td, row, col, prop, value, cellProperties) {
              Handsontable.renderers.TextRenderer.apply(this, arguments);
              td.innerHTML = '<button style="margin-top: 10px; margin-bottom: 10px" class="btn btn-default btn-sm">Select</button>';
            };
          }
          return cellPrp;
        },
        afterOnCellMouseDown: async (event, coords, td) => {
           
          let buttonClicked = coords.col === 0 && event.target.localName === "button";

          // If multiple values from Related Table
          if (buttonClicked && this.allowMultipleValuesFromForeignTable) {
          let { id, name } = this.$refs.secondHot.hotInstance.getSourceDataAtRow(coords.row);

            if (this.idsAndNamesFromForeignTable.filter(obj => obj.id === id).length > 0) {
              this.idsAndNamesFromForeignTable = this.idsAndNamesFromForeignTable.filter(obj => obj.id !== id);
            } else {
              this.idsAndNamesFromForeignTable.push({ id, name });
            }
          } else if (buttonClicked) {
            // If only one value from Related Table
            let id = this.$refs.secondHot.hotInstance.getSourceDataAtRow(coords.row);
            let colToRender = this.$refs.hot.hotInstance.getCellMeta(this.cellRowClicked, this.cellColClicked).__proto__.colToRender;
            let colToUpdate = this.$refs.hot.hotInstance.getCellMeta(this.cellRowClicked, this.cellColClicked).__proto__.colToUpdate;
            let colRenderAlias = this.$refs.hot.hotInstance.getCellMeta(this.cellRowClicked, this.cellColClicked).__proto__.colRenderAlias;

            let fieldValue = colRenderAlias ? colRenderAlias.split(".")  : colToRender.split(".") ;
            let fieldPath = id;
            for (let i = 1; i < fieldValue.length; i++) {
                fieldPath = fieldPath[fieldValue[i]]
            }

           //let idField = `${this.$refs.hot.hotInstance.getCellMeta(this.cellRowClicked, this.cellColClicked).__proto__.relatedTable}`;
            let idField = fieldValue[0];
           // let colToRender = `${this.$refs.hot.hotInstance.getCellMeta(this.cellRowClicked, this.cellColClicked).__proto__.colToRender}`;

            idField = idField === "people" ? "person" : idField;
            idField = `${idField}.id`;
            this.$refs.hot.hotInstance.setCellMeta(this.cellRowClicked, this.cellColClicked, 'valueToRender', fieldPath);
            this.$refs.hot.hotInstance.setDataAtCell(this.cellRowClicked, this.cellColClicked, id["id"]);
            this.$refs.hot.hotInstance.render()
            // Then close the modal and clear the search inputs.
            this.openSecondHot = false;
            this.secondHotColumns.slice(1).forEach(col => {
              this.$refs[col.data][0].value = "";
            });
          } else {
            return;
          }
        }
      }
    };
  }
};

Handsontable.renderers.registerRenderer("safeHtmlRenderer", function(hotInstance, td, row, column, prop, value, cellProperties) {
  //var escaped = Handsontable.helper.stringify(value);
  //escaped = strip_tags(escaped, '<em><b><strong><a><big>'); //be sure you only allow certain HTML tags to avoid XSS threats (you should also remove unwanted HTML attributes)
  //td.innerHTML = escaped;

  td.innerHTML = '<button style="margin-top: 10px; margin-bottom: 10px" class="btn btn-default btn-sm">Select</button>';

  return td;

  Handsontable.renderers.getRenderer("safeHtmlRenderer").apply(this, arguments);
});

// to display a submit button after every row
Handsontable.renderers.registerRenderer("submitButton", function(hotInstance, td, row, column, prop, value, cellProperties) {
  td.innerHTML = '<button style="height: 100%; width: 100%; color: #FFFFFF;" class="submit-button-workflow btn btn-primary btn-default btn-xs">Submit</button>';
  return td;
});

Handsontable.renderers.registerRenderer("downLoadButton", function(hotInstance, td, row, column, prop, value, cellProperties) {
  if (value == null){
    // empty 
  } else {
   td.innerHTML = '<button style="height: 100%; width: 100%; color: #FFFFFF;"  class="submit-button-workflow btn btn-primary btn-default btn-xs">Download</button>';
   return td;
 }
});

Handsontable.renderers.registerRenderer("maxCharLengthRow", function(hotInstance, td, row, column, prop, value, cellProperties) {
  if (value == null) {
    td.innerHTML = "";
  } else {
    td.innerHTML = shorten(value, 300, " ");
    if (value.length > 300) {
      td.innerHTML += "<p>...</p>";
    }
  }
  return td;
});

Handsontable.renderers.registerRenderer("filenameRenderer", function(hotInstance, td, row, column, prop, value, cellProperties) {
  const isAdd = window.location.href.includes('add');
  // remove any query params and the pound sign that's added after uploading a new photo
  const tableName = window.location.href.split('/').pop().replace('#', '').split('?')[0];

  // don't allow editing of photo for people_photos edit view
  if (tableName === 'people_photos' && !isAdd) {
    hotInstance.setCellMeta(row,column,'readOnly',true);
  }

  let cellMeta = hotInstance.getCellMeta(row, column);
  if(cellProperties.readOnly === true){
     td.className = 'htDimmed';
  }
  if (!value) {
    td.innerHTML = '<i>no image</i>';
  } else {
    // display larger thumbnails for some tables
    const showBigThumbnails = ['files', 'people_photos', 'submitted_photos_staging', 'survey_photos_staging', 'tiktok_people_photos'];
    const photoPath = cellMeta.photoInfo ? cellMeta.photoInfo.photo : value; 
    const thumbnailSize = showBigThumbnails.includes(tableName) ? 200 : 100;
    const photoWidth = showBigThumbnails.includes(tableName) ? 120 : 60;
    td.innerHTML = `<a href="#"><img src="https://ballotpedia-api4.s3.amazonaws.com/files/thumbs/${thumbnailSize}/${thumbnailSize}/${photoPath}" style="width:${photoWidth}px; height:auto;" /></a>`;
  }

  return td;
});
Handsontable.renderers.registerRenderer("relatedTableRenderer", function(hotInstance, td, row, column, prop, value, cellProperties) {
  let cellMeta = hotInstance.getCellMeta(row, column);
  let valToRender;
  if (cellProperties.valid === false){
       td.className = 'htInvalid';
  }
  if(cellProperties.readOnly === true){
     td.className = 'htDimmed';
  }
  if (cellMeta.valueToRender === null || cellMeta.valueToRender){
      valToRender = cellMeta.valueToRender
  }else{
      valToRender = hotInstance.getDataAtRowProp(row, cellMeta.__proto__.colToRender);
  }

  if (valToRender !== null && (typeof valToRender != 'object')) {
      td.innerHTML = valToRender;
  } else {
    td.innerHTML = value == null ? "" : value;
  }

 return td;
});
Handsontable.renderers.registerRenderer("mwTemplateRenderer", function(hotInstance, td, row, column, prop, value, cellProperties) {
  
  if (typeof value != 'string' || value == null || value.trim().length < 1  || value == '{}'){
    td.innerHTML = "";
    hotInstance.setCellMeta(row,column,'readOnly',true);

  } else {
    td.innerHTML = 'Click to see generated templates.'
    hotInstance.setCellMeta(row,column,'readOnly',false);
  
  }
  return td;
});
Handsontable.renderers.registerRenderer("htmlLinkRenderer", function(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  try{
    if (value != null && value.indexOf('http') !== -1 && value.indexOf(';') === -1) {
      // for links to other HOT pages, don't display the full URL (very long)
      if (value.includes('data.ballotpedia.org') || value.includes('localhost')) {
        td.innerHTML = `<a href="${encodeURI(decodeURI(value))}" target="_blank">Link</a><br>`;
      } else {
        td.innerHTML = '<a href="' + encodeURI(decodeURI(value)) + '" target="_blank">' + value + '</a><br>';
      }
      return td;
    } else {
      return value;
    }
  }catch (e){
      return value;
  }
});
Handsontable.renderers.registerRenderer("ellipsisRenderer", function(hotInstance, td, row, column, prop, value, cellProperties) {
  td.style.whiteSpace = 'nowrap'
  td.style.textOverflow = 'ellipsis'
  td.className = 'htMiddle'
  td.innerHTML = value
  return td
 
});
Handsontable.renderers.registerRenderer("wysiwygRenderer", function(hotInstance, td, row, column, prop, value, cellProperties) {
  if (value == null) {
    td.innerHTML = "";
  } else {
  // if the WYSIWYG content begins with an image or an iframe, resize it before rendering
  // so the cells aren't humongous
  value = value.replace(/<img/g,"<img style=\"width:100% !important; height: auto;\"");
  value = value.replace(/<iframe/g,"<iframe style=\"width:100% !important; height: auto;\"");
    td.innerHTML = shorten(value, 120, " ");
    if (value.length > 120) {
      td.innerHTML += "...";
    }
  }
  return td;
});
Handsontable.renderers.registerRenderer("viewButton", function(hotInstance, td, row, column, prop, value, cellProperties) {
  if (value == null){
    // empty 
  } else {
   td.innerHTML = '<a style="height: 100%; width: 100%; color: #FFFFFF;"  class="submit-button-workflow btn btn-primary btn-default btn-xs" href="'+value+'">View</a>';
   return td;
 }
});
Handsontable.renderers.registerRenderer("promoteToGoldRenderer", function(hotInstance, td, row, column, prop, value, cellProperties) {
 const promote_statuses = ['Can be Promoted', 'Page not created']

 if (promote_statuses.includes(hotInstance.getDataAtCell(row,hotInstance.propToCol('contest_status')))) {
      Handsontable.renderers.CheckboxRenderer.apply(this, arguments);
      td.style.pointerEvents = ''; // allow interaction
      td.classList.remove('htDimmed')
  } else {
    // Blank, readonly rendering
      td.textContent = '';
      td.style.pointerEvents = 'none'; // Disable interaction
      td.classList.add('htDimmed'); // Optional visual cue
  }

  return td;
}   
  
);
Handsontable.renderers.registerRenderer("nullAwareCheckbox", function(hotInstance, td, row, col, prop, value, cellProperties) {
  //console.log('RENDERING NULL AWARE CHECKBOX')
  Handsontable.dom.empty(td);
    
  let cellMeta= hotInstance.getCellMeta(0, col);
  const checkbox = document.createElement("input");
  checkbox.type = "checkbox"; 
  checkbox.className = "htCheckboxRendererInput";
 
  if (cellMeta.__proto__.readOnly === true || cellMeta.__proto__.readOnly === 'true' || cellMeta.__proto__.readOnly === 1){
    td.classList.add('htDimmed');
    checkbox.disabled = true;
  } 
  if (cellProperties.valid === false){
      td.classList.add('htInvalid');
  }
  td.classList.add('htMiddle');
  //checkbox.style.margin = '0';
  checkbox.style.verticalAlign = 'middle';
   
  if (value === null  && hotInstance.getSettings().dataSchema){
     //let cellMeta= hotInstance.getCellMeta(0, col);
     if(cellMeta.default_value !=null && cellMeta.default_value != undefined && cellMeta.dataType === 'boolean'){
        //console.log('default value is ', cellMeta.default_value)
        value = JSON.parse(cellMeta.default_value);
        //console.log('setting attribute'); 
        td.setAttribute('data-value', String(value));
     } 
  }
     
   
  checkbox.indeterminate = false;
  
  // Set visual state based on value
  if (value === true) {
    checkbox.checked = true;
    checkbox.indeterminate = false;
  } else if (value === false) {
    checkbox.checked = false;
    checkbox.indeterminate = false;
  } else {
    checkbox.checked = false;
    checkbox.indeterminate = true;  // NULL -> display as indeterminate
  }

  checkbox.addEventListener("change", function (e) {
    e.stopPropagation();
     
    let nextValue;
    let cellMeta= hotInstance.getCellMeta(0, col);
   
    //console.log('cellMeta is ', cellMeta)
    if(cellMeta.default_value !=null && cellMeta.default_value != undefined && cellMeta.dataType === 'boolean'){
      if (value === null) {
          nextValue = JSON.parse(cellMeta.default_value);
      } else if (value === false) {
          nextValue = true;
      } else  {
          nextValue = false;
      }
    } else {
    if (value === null) {
      nextValue = false;
    } else if (value === false) {
      nextValue = true;
    } else {
      nextValue = null;
    }
    }

    hotInstance.setDataAtCell(row, col, nextValue, "triToggle");
  });

   td.appendChild(checkbox);
  return td;
});

Handsontable.renderers.registerRenderer("TypeAheadSearch", function(hotInstance, td, row, column, prop, value, cellProperties) {

  let cellMeta = hotInstance.getCellMeta(row, column);
  let valToRender;
  if (cellProperties.valid === false){
       td.className = 'htInvalid';
  }
  if(cellProperties.readOnly === true){
     td.className = 'htDimmed';
  }
  if (cellMeta.valueToRender === null || cellMeta.valueToRender){
      valToRender = cellMeta.valueToRender
  }else{
      valToRender = hotInstance.getDataAtRowProp(row, cellMeta.__proto__.colToRender);
  }

  if (valToRender !== null && (typeof valToRender != 'object')) {
      td.innerHTML = valToRender;
  } else {
    td.innerHTML = value == null ? "" : value;
  }
  
  
  return td;
});
// Shorten a string to less than maxLen characters without truncating words.
function shorten(str, maxLen, separator = " ") {
  if (str.length <= maxLen) return str;
  return str.substr(0, str.lastIndexOf(separator, maxLen));
}

class WYSIWYGEditor extends Handsontable.editors.TextEditor {
  open() {
    // display editor
    var itm = document.getElementById("editor_container");
    itm.style.display = "block";
  }
}
Handsontable.editors.registerEditor("wysiwyg", WYSIWYGEditor);

// same as wysiwyg, except no HTML tags are added to the text
// helpful for long text columns that are more easily edited in the wysiwyg popup window
class WYSIWYGNoHtmlEditor extends WYSIWYGEditor {}
Handsontable.editors.registerEditor("wysiwygNoHtml", WYSIWYGNoHtmlEditor);

// This is heavily based on https://handsontable.com/docs/7.1.1/tutorial-cell-editor.html#page-creating-custom-editor

class FileEditor extends Handsontable.editors.TextEditor {
  open() {
    // display modal with file uplaod window
    var itm = document.getElementById("file_editor_container");
    itm.style.display = "block";
  }
}

Handsontable.editors.registerEditor("file", FileEditor);

class TypeAheadEditor extends Handsontable.editors.HandsontableEditor {
  prepare(row, col, prop, td, value, cellProperties) {
    super.prepare(row, col, prop, td, value, cellProperties);

    Object.assign(this.htOptions, {
      data: this.cellProperties.source,
      columns: [
        {
          data: '_id',
        },
        {
          data: 'label',
        },
      ],
      hiddenColumns: {
        columns: [1],
      },
      colWidths: cellProperties.width - 1,
      beforeValueRender(value, { row, instance }) {
        return instance.getDataAtRowProp(row, 'label');
      },
    });

    if (cellProperties.typeAheadCells) {
      this.htOptions.cells = cellProperties.typeAheadCells;
    }
    //if (this.htEditor) {
     // this.htEditor.destroy();
    //}
    //this.htEditor = new Handsontable(this.htContainer, this.htOptions);
  }
  
  setValue(value) {
    if (this.htEditor) {
      const index = this.htEditor.getDataAtProp('_id').findIndex(id => id === value);

      if (index !== -1) {
        value = this.htEditor.getDataAtRowProp(index, 'label');
      }
    }
    super.setValue(value);
  }
  
  getValue() {
    const value = super.getValue();

    if (this.htEditor) {
      const labels = this.htEditor.getDataAtProp('label');
      const row = labels.indexOf(value);

      if (row !== -1) {
        return this.htEditor.getDataAtRowProp(row, '_id');
      }
    }

    return value;
  }
}

const typeAheadValidator = function(value, callback) {
  let valueToValidate = value;

  if (valueToValidate === null || valueToValidate === void 0) {
    valueToValidate = '';
  }

  if (this.allowEmpty && valueToValidate === '') {
    callback(true);
  } else {
    callback(this.source.find(({ _id }) => _id === value) ? true : false);
  }
};
const TypeAheadRenderer = function(hot, TD, row, col, prop, value, cellProperties) {
  const item = cellProperties.source.find(({ _id }) => _id === value);
  if (item) {
    value = item.label;
  }
  
  Handsontable.renderers.getRenderer('autocomplete').call(hot, hot, TD, row, col, prop, value, cellProperties);
};


Handsontable.cellTypes.registerCellType('type-ahead-list', {
  editor: TypeAheadEditor,
  validator: typeAheadValidator,
  renderer: TypeAheadRenderer,
});

Handsontable.editors.registerEditor("TypeAheadEditor", TypeAheadEditor);
Handsontable.renderers.registerRenderer("TypeAheadRenderer", TypeAheadRenderer);
</script>
<style src="../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style scoped>

.console {
  position: absolute;
  right: 48px;
  top: 75px;
  width: 400px;
  height: 100px;
  overflow: scroll;
  display: flex;
  flex-direction: column-reverse;
}

.console hr {
  margin-top: 0;
  margin-bottom: 0;
}

.well {
  padding-bottom: 10px;
}

.modal-mask {
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 75%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  text-align: center;
}

.modal-container .btn {
  margin: 0 auto;
}

.modal-header {
  margin-top: 0;
  color: #2c3e50;
  font-size: 30px;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  margin: 0 auto;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.fa-link:hover {
  cursor: pointer;
}

:deep(.handsontable .colHeader) {
  white-space: normal !important;
}
</style>
